import { reducer as gamesReducer } from './games.slice';

export default gamesReducer;
